/**
 * Timeline Block - Interactivity API View Script
 *
 * Scroll-triggered fade-in animation for timeline items.
 *
 * @package BrandyBlocks
 */

import { store, getContext, getElement } from '@wordpress/interactivity';

store( 'brandy/timeline', {
	callbacks: {
		init() {
			const ctx = getContext();
			const { ref } = getElement();

			if ( ! ctx.animate ) {
				return;
			}

			const items = ref.querySelectorAll( '.brandy-timeline-item' );
			if ( ! items.length ) {
				return;
			}

			// Mark parent as animated — CSS hides items only after this class is added.
			ref.classList.add( 'brandy-timeline--animated' );

			const observer = new IntersectionObserver(
				( entries ) => {
					entries.forEach( ( entry ) => {
						if ( entry.isIntersecting ) {
							entry.target.classList.add( 'is-visible' );
							observer.unobserve( entry.target );
						}
					} );
				},
				{ threshold: 0.2 }
			);

			items.forEach( ( item ) => observer.observe( item ) );

			return () => observer.disconnect();
		},
	},
} );
